/*
 * Import all the necessities
 */
import VueRouter from 'vue-router'
import CatalogFilterRoot from './components/catalog-filter/catalog-filter-root'
import ArtworksContestRoot from './components/artworks-contest/artworks-contest-root'
Vue.use(VueRouter)

const routes = [
    { path: '/:locale/:catalog/:edition/:slug?' },
    { path: '/:locale/:catalog' },
];

const router = new VueRouter({
    mode: 'history',
    routes // short for `routes: routes`
})

let app = new Vue({
    el: '#catalog-filter',
    router,
    components: {
        'alf-catalog-filter-root': CatalogFilterRoot,
        'alf-artworks-contest-root': ArtworksContestRoot
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/site/app-catalog-filter.js